import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { getDefaultStore } from 'jotai';

import { lastAllowedStepAtom } from '@/features/onboarding/atoms/steps';
import { OnboardingHeader } from '@/features/onboarding/components/header';
import { isStep, stepIndex } from '@/features/onboarding/utils/steps';

const STEP_PATH_REGEX = /^\/onboarding\/([^/]+)$/;

/** Extracts step ID from pathname: /onboarding/age -> 'age' */
const extractStepId = (pathname: string): string | undefined => {
  return STEP_PATH_REGEX.exec(pathname)?.[1];
};

export const Route = createFileRoute('/_protected/onboarding/_steps')({
  component: RouteComponent,
  beforeLoad: ({ location }) => {
    const stepId = extractStepId(location.pathname);

    if (stepId && isStep(stepId)) {
      const store = getDefaultStore();
      const lastAllowed = store.get(lastAllowedStepAtom);
      if (stepIndex(stepId) > stepIndex(lastAllowed)) {
        throw redirect({
          to: `/onboarding/${lastAllowed}`,
          replace: true,
        });
      }
      return { stepId };
    }
    throw redirect({
      to: `/onboarding`,
      replace: true,
    });
  },
  loader: ({ context }) => {
    return {
      stepId: context.stepId,
    };
  },
});

function RouteComponent() {
  const loaderData = Route.useLoaderData();

  const stepId = loaderData.stepId;

  return (
    <div className="from-purple-brand-900 p-safe relative flex min-h-dvh w-full flex-col bg-linear-to-b/oklch to-black">
      <div className="mx-auto flex h-full w-full max-w-160 flex-1 flex-col px-4 pb-6 md:mt-10 md:max-h-192 ">
        <OnboardingHeader stepId={stepId} />
        <Outlet />
      </div>
    </div>
  );
}
